const state = {
  alert: {
    status: false,
    message: '',
    type: '',
    keepAlive: false,
  },
  loader: {
    showing: false,
  },
  showEmptyState: false,
  language: null,
  displayDeleteModal: false,
  currency: 'USD',
  theme: 'default',
  enableAnonymousTracking: true,
  implementError: false,
}

export default state
